import * as yup from 'yup'
import { ApplicationFormAnswers } from '../components/ApplicationForm/ApplicationFormContext'
import BaseValidator from './BaseValidator'

const rules = {
  messages: {
    error: 'Please enter your monthly take home pay',
    helper: 'Please double-check your monthly income for accuracy.'
  },
  thresholds: {
    valid: {
      min: 100,
      max: 99999999
    },
    helper: {
      min: 10000,
      max: 99999999
    }
  }
}


const MonthlyIncomeValidator = (): BaseValidator & { validateHelperMessage: (input:string) => string } => {
  const schema = yup.object().shape({
    monthlyIncome: yup.number()
      .typeError(rules.messages.error)
      .min(rules.thresholds.valid.min, rules.messages.error)
      .max(rules.thresholds.valid.max, rules.messages.error)
      .required(rules.messages.error)
  })

  return {
    getValidator: () => schema,
    validateState: (state: ApplicationFormAnswers) => schema.isValidSync({
      monthlyIncome: state.monthlyIncome
    }),
    validateHelperMessage: (input: string) => {
      const inputValue = Number(input)
      const { min: helperMin, max: helperMax } = rules.thresholds.helper

      if (inputValue >= helperMin && inputValue <= helperMax) {
        return rules.messages.helper
      }
      return ''
    }
  }
}

export {
  MonthlyIncomeValidator,
  rules as monthlyIncomeValidationRules
}
